import React, { useState, useCallback, useEffect } from "react";
import { MdContentCopy } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import img from "../../../assets/GLpageSmapleImages/img.svg";
import GLpageTemplatePopup from "./GLpageTemplatePopup";
import GLPagesService from "../../Services/GLPagesService";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { ToastContainer } from "react-toastify";
import { showErrorToast, showInfoToast, showSuccessToast } from "../../Constant/Notification";
import { getIcons, userRole } from "../../Constant/Constant";
import { MdOutlineDownloadForOffline } from "react-icons/md";
import CustomHeading from "../../common/CustomHeading";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import { glPageUrl } from "../../../config/clientsConfig";
import { FiSearch } from "react-icons/fi";

const defaultImage = img;

const GLpagesViewList = () => {
  const navigate = useNavigate();
  const [openPopup, setOpenPopup] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const icons = getIcons();
  const [GLPagesList, setGLPagesList] = useState([]);
  const [GLpageStatus, setGLpageStatus] = useState(false);
  const [filteredGLPages, setFilteredGLPages] = useState([]);
  const [enquiriesData, setEnquiriesData] = useState({});
  const [loadingEnquiry, setLoadingEnquiry] = useState(null);
  const [nextPropertyId, setNextPropertyId] = useState("");
  const [prevPropertyId, setPrevPropertyId] = useState("");

  const [search, setSearch] = useState("");

  const handleClosePopup = useCallback(() => {
    setOpenPopup(false);
  }, []);

  const path = getBasePathByUserRole()
  const handleGLPageInfo = (id) => {
    navigate(`${path}/gl-pages-creating`, {
      state: { GLPageId: id , isEditMode : true },
    });
  };

  const GetGLPagesList = async (id = "", direction = "next", isInitialLoad = false) => {
    if (isFetching) return;

    setIsFetching(true);
    try {
      const response = await GLPagesService.GetViewGLPages(id, direction);
      if (response) {
        if (isInitialLoad || id === "") {
          setGLPagesList(response?.dataArray || []);
          setFilteredGLPages(response?.dataArray || []);
        } else {
          setGLPagesList((prev) => [...prev, ...response?.dataArray]);
          setFilteredGLPages((prev) => [...prev, ...response?.dataArray]);
        }
        setNextPropertyId(response.next || null);
        setPrevPropertyId(response.prev || null);
      }
    } catch (error) {
      console.error("Error fetching GL Pages:", error.response?.data || error.message);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100 &&
        !isFetching &&
        nextPropertyId
      ) {
        GetGLPagesList(nextPropertyId, "next");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, nextPropertyId]);

  const downloadExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Enquiries");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const GetEnquiriesData = async (pageId) => {
    try {
      setLoadingEnquiry(pageId);
      const response = await GLPagesService.GetEnquiries(pageId);
      console.log("Enquiries:", response);

      if (response && response.length) {
        downloadExcel(response, `Enquiries_${pageId}`);
      } else {
        showInfoToast("No enquiries data available for download.");
      }
    } catch (error) {
      console.error(
        "Error fetching Enquiries:",
        error.response?.data || error.message
      );
      showErrorToast("Failed to fetch enquiries data.");
    } finally {
      setLoadingEnquiry(null);
    }
  };

  const UpdateGlPageStatus = async (id, currentStatus) => {
    if (!id) {
      console.error("GL Page ID is required to update status.");
      return;
    }
    
    const newStatus = !currentStatus;
    setGLPagesList((prevList) =>
      prevList.map((item) =>
        item.id === id
          ? { ...item, data: { ...item.data, status: newStatus } }
          : item
      )
    );

    try {
 
      await GLPagesService.UpdateGLPageStatus(id, newStatus);

      showSuccessToast(
        `Status has been ${newStatus ? "enabled" : "disabled"} successfully`
      );
      
   
      setFilteredGLPages((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: newStatus } }
            : item
        )
      );
    } catch (error) {
      console.error(
        "Error updating GL Page status:",
        error.response?.data || error.message
      );
      
      // Revert optimistic update on error
      setGLPagesList((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: currentStatus } }
            : item
        )
      );
      setFilteredGLPages((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: currentStatus } }
            : item
        )
      );
    }
  };

  const handleCopyToClipboard = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        showSuccessToast("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };

  useEffect(() => {
    GetGLPagesList("", "next", true); // Pass true for initial load
  }, []);

  useEffect(() => {
    setFilteredGLPages(
      GLPagesList.filter(
        (item) =>
          item.data?.propertyData?.propertyName &&
          item.data?.propertyData?.propertyName
            .toLowerCase()
            .includes(search.toLowerCase())
      )
    );
  }, [search, GLPagesList]);

  const handleTeamplate = () => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
    navigate(`${path}/gl-pages-template`);
  };

  return (
    <div className="bg-appGrayBackground pt-28">
      <ToastContainer />
       <AdminAppBar />
      <div className="flex px-10 justify-between items-center">
        {/* <div>
          <h1 className="text-3xl font-bold font-poppins text-gray-900">
            GL Property Pages
          </h1>
        </div> */}
       <div className="flex items-center gap-5">
       <CustomHeading title={"GL Property Pages"} isIcon={true} />
        <form className=" mx-auto">
          <label
            htmlFor="default-search"
            className=" text-sm font-medium text-gray-900 sr-only"
          >
            Search
          </label>
          {/* <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                className="w-4 h-4 text-emerald-700"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-[500px] p-1 ps-10 h-10 text-sm text-gray-900 border rounded bg-gray-50 border-solid border-slate-400"
              placeholder="Search property"
              required
              onChange={(e) => setSearch(e.target.value)}
            />
          </div> */}
          <form
             //  onSubmit={handleSearchSubmit}
               className={`relative w-full md:w-[385px] `}
             >
               <input
                 type="search"
              id="default-search"
                 placeholder="Search property"

                 onChange={(e) => setSearch(e.target.value)}
                 className="w-full pl-4 pr-14 h-[50px] border border-gray-300 rounded-[10px] shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-customGreen"
               />
               <button
                 type="submit"
                 className="absolute right-0 top-0 h-[50px] w-[50px] bg-customGreen text-white rounded-r-[10px] flex items-center justify-center hover:bg-green-600 transition"
               >
                 <FiSearch size={20} />
               </button>
             </form>
        </form>
       </div>

        <div className="flex gap-4 items-center">
          <button
            onClick={handleTeamplate}
            className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center"
          >
            + Create Home Page
          </button>
          <button
            onClick={() => setOpenPopup(!openPopup)}
            className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center"
          >
            + Create New Template
          </button>
        </div>
      </div>
      <div className="mx-auto py-10">
  {filteredGLPages.length > 0 ? (
    <div className="grid px-4 sm:px-6 lg:px-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {filteredGLPages.map((item) => (
        <div
          key={item.id}
          className="bg-white border border-gray-200 p-2 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
        >
          {/* Card Header */}
          <div className="flex justify-between items-center pb-3 border-b border-gray-100">
            <div className="truncate">
              <span className="text-gray-600">Property: </span>
              <span className="font-medium text-gray-900 truncate">
                {item.data.propertyData?.propertyName || "Unnamed Property"}
              </span>
            </div>
            <button 
              onClick={() => handleGLPageInfo(item.id)}
              className="text-gray-500 hover:text-emerald-600 transition-colors p-1"
              aria-label="Edit property"
            >
              <FiEdit className="w-5 h-5" />
            </button>
          </div>

          {/* Property Image */}
          <div className="relative aspect-video">
            <img
              src={item.data.hero?.bannerImages?.[0] || defaultImage}
              alt={item.data.propertyName || "Property image"}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            {item.data.pageStyle?.label && (
              
              <div className={`absolute top-3  right-3 px-2 py-1 text-xs font-medium rounded-full shadow-sm ${item.data.pageStyle?.color} bg-opacity-90`}>
                {item.data.pageStyle?.label}
              </div>
            )}
          </div>

          {/* Stats Section */}
          <div className="p-4">
            <div className="flex justify-between items-center bg-gray-50 rounded-lg px-4 py-3 mb-4">
              <div className="text-center">
                <p className="text-xl font-bold text-gray-800">{item.data.totalVisits || 0}</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Visits</p>
              </div>
              
              <div className="w-px h-8 bg-gray-300" />
              
              <div className="text-center">
                <p className="text-xl font-bold text-gray-800">{item.data.totalEnquiries || 0}</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Enquiries</p>
              </div>
              
              <div className="w-px h-8 bg-gray-300" />
              
              <div className="text-center">
                <label className="inline-flex items-center mb-1 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={item.data?.status}
                    onChange={() => UpdateGlPageStatus(item.id, item.data?.status)}
                    className="sr-only peer"
                  />
                  <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
   
                </label>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Status</p>
              </div>
            </div>

            {/* Action Buttons */}
            <button
              onClick={() => GetEnquiriesData(item.id)}
              className="w-full flex items-center justify-center gap-2 text-emerald-600 hover:text-emerald-700 border border-emerald-500 rounded-md px-4 py-2 mb-3 text-sm font-medium hover:bg-emerald-50 transition-colors"
            >
              <MdOutlineDownloadForOffline className="w-5 h-5" />
              <span>Download Enquiries</span>
            </button>

            {/* URL with Copy */}
            <div className="group relative">
              <div className="flex items-center rounded-md border border-gray-300 overflow-hidden">
                <a
                  href={`${glPageUrl}/gl-page/${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 py-2 px-3 text-sm text-blue-600 hover:text-blue-700 hover:underline truncate"
                >
                  {`${glPageUrl}/gl-page/${item.id}`}
                </a>
                <button
                  onClick={() => handleCopyToClipboard(`${glPageUrl}/gl-page/${item.id}`)}
                  className="px-3 py-2 bg-gray-100 hover:bg-gray-200 transition-colors border-l border-gray-300"
                  aria-label="Copy link"
                >
                  <MdContentCopy className="w-4 h-4 text-gray-600" />
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <img
        src={icons?.glPageEmpty}
        alt="No GL Pages"
        className="w-64 h-auto mb-6 opacity-80"
      />
      <h3 className="text-lg font-medium text-gray-900 mb-2">No GL Pages Found</h3>
      <p className="text-gray-500 max-w-md mx-auto">
        You haven't created any GL pages yet. Create your first page to get started.
      </p>
    </div>
  )}
</div>

      {openPopup && <GLpageTemplatePopup ClosePopup={handleClosePopup} />}
    </div>
  );
};

export default GLpagesViewList;